
const platsByNumberReducer = (state = [{code: "ALL", description: "All"}], action) => {
  switch (action.type) {
    case 'LANDLINK_PLATS_SORTED_BY_NUMBER':
      return action.results;
    default:
      break;
  }
  return state;
}

export default platsByNumberReducer;